import React, { useState, useEffect, useRef, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import PublishIcon from "@material-ui/icons/Publish";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import AuthContext from "../../../context/auth-context";
import { StockService } from "../../../services/stock-service";
import Select from "react-select";
import { ProductService } from "../../../services/product-service";
import SearchList from "./SearchList";

export const Content = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [createHide, setCreateEdit] = useState(true);
  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }

      if (
        loca.access_module.module_name == "STOCKS" &&
        loca.permission_add === true
      ) {
        setCreateEdit(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";

  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const handleChangeSearchTerm = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const [stockID, setStockID] = useState();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setStockID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const [stock, setStock] = useState([]);
  const [productId, setProductId] = useState("");
  const [products, setProductDetails] = useState([]);
  const [selectedProductOption, setSelectedProductOption] = useState(null);


  const productSearch = async () => {
    try {
      const result = await ProductService.allproductsNames();
      setProductDetails(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const ProductDetails = products.map((product) => {
    const container = {};

    container["value"] = product.id;
    container["label"] = product.name;
    return container;
  });
  

  const stockSearch = async (productId = "") => {
    try {
      const result = await StockService.stockDetails(rowsPerPage, page, searchTerm, productId);
      console.log('stock', result.results)
      setStock(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await StockService.stockDelete(stockID);

      setSubmitLoading(true);
      notify("Stock successfully deleted");
      handleClose();
      stockSearch();
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }

      //show error toast
    }
  };
  
  useEffect(() => {
    productSearch();
  }, []);
  
  useEffect(() => {
    stockSearch(productId);
  }, [productId, rowsPerPage, page, searchTerm]);
  

  const handleProductChange = (selectedOption, index) => {
    setSelectedProductOption(selectedOption);
    setProductId(selectedOption ? selectedOption.value : "");
    // stockSearch(selectedOption ? selectedOption.value : "");
  };

  const ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
    keyword: product.name.toLowerCase(),

  }));

   const filterProductOption = (option, rawInput) => {
    const search = rawInput.toLowerCase().trim();
    const keywords = search.split(/\s+/); // split by spaces
    const optionText = option.data.keyword;
    
    return keywords.every((keyword) => optionText.includes(keyword));
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const clearFilters = () => {
    productSearch();
    setSelectedProductOption(null);
    setProductId("");
    setSearchTerm("");
    setPage(0);
    setRowsPerPage(10);
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "product",
      headerName: "Product",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{params.row.product.name}</div>;
      },
    },
    // {
    //   field: "invoice_item_id",
    //   headerName: "Invoice Item Id",
    //   flex: 2,
    //   cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   headerClassName: `custom-header ${ctx.darkMode ? "active_dark" : "deactive_dark"}`,
    //   headerAlign: "center",  // Aligns the header text
    //   align: "center",
    //   // renderCell: (params) => {
    //   //   return <div>{params.row.product_color.name}</div>;
    //   // },
    // },
    {
        field: "invoice_number",
        headerName: "Invoice No",
        flex: 2,
        cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
        headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
        headerAlign: "center",  // Aligns the header text
        align: "center",
    },
    {
      field: "incomingInvoice",
      headerName: "Comment",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "left",
      renderCell: (params) => {
        console.log('params',params.row.incomingInvoice)
        return <div>{params?.row?.incoming_invoice_id !== 0 ? params?.row?.incomingInvoice?.comment : (params?.row?.dispatch_id !== 0 ? params?.row?.dispatch.comment : "")}</div>;
      },
    },
    {
        field: "quantity",
        headerName: "Quantity",
        flex: 2,
        cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
        headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
        headerAlign: "center",  // Aligns the header text
        align: "center",
        renderCell: (params) => {
          if(params.row.dispatch_id !== 0){
            return <div>{'-' + params.row.quantity}</div>;
          }else if(params.row.incoming_invoice_id !== 0){
            return <div>{'+' + params.row.quantity }</div>;
          }
          
        },
    },
    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   sortable: false,
    //   flex: 3,
    //   disableClickEventBubbling: true,
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   renderCell: (params) => {
    //     if (params.row.status === "ACTIVE") {
    //       return (
    //         <div>
    //           <span className="badge badge-success">ACTIVE</span>
    //         </div>
    //       );
    //     } else {
    //       return (
    //         <div>
    //           <span className="badge badge-primary">DEACTIVE</span>
    //         </div>
    //       );
    //     }
    //   },
    // },
    // {
    //   field: "delete",
    //   headerName: "Delete",
    //   sortable: false,
    //   flex: 2,
    //   disableClickEventBubbling: true,
    //   headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    //   renderCell: (params) => {
    //     return (
    //       <div hidden={deleteHide}>
    //         <i
    //           className="far fa-trash-alt ms-text-danger"
    //           onClick={() => {
    //             handleShow4(params.row.id);
    //           }}
    //           style={{ cursor: "pointer" }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-10">
                  <h6>Stock List </h6>
                </div>
                <div>
                  <Modal
                    show={state.show4}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        Confirm Deletion
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "2vh",
                      }}
                    >
                      <h6 style={{ color: "red" }}>
                        Are you sure you want to remove this item ?
                      </h6>
                    </div>
                    <Modal.Footer>
                      <div className="col-md-2" hidden={submitloading}>
                        <div className="spinner spinner-7">
                          <div className="bounce1" />
                          <div className="bounce2" />
                          <div className="bounce3" />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        // onClick={submitForm}
                        style={{ backgroundColor: "red" }}
                        onClick={onDelete}
                      >
                        Delete
                      </button>

                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="col-md-4 mt-4">
                  <Select
                    options={ProductOptions}
                    onChange={handleProductChange}
                    isClearable
                    placeholder="Filter by Product"
                    filterOption={filterProductOption}
                    value={selectedProductOption}
                  />
                </div>
                <div className="col-md-4 mt-2">
                    <SearchList
                      handleChange={handleChangeSearchTerm}
                      searchTerm={searchTerm}
                    />
                </div>
                <div className="col-md-1">
                <label htmlFor="validationCustom15"></label>
                <div className="input-group">
                  <button
                      type="button"
                      className="btn btn-secondary shadow-none"
                      onClick={clearFilters}
                  >
                    Clear
                  </button>
                </div>
              </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                  <DataGrid
                    rows={stock}
                    columns={columns}
                    disableExtendRowFullWidth={false}
                    pageSize={rowsPerPage}
                    pagination
                    hideFooter
                    autoHeight
                  />
                  <TablePagination
                    component="div"
                    count={count}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
